import { useCallback, useEffect, useState } from 'react';
import { TTopCategory } from 'data';
import { countNumberOfAllRows } from 'utils';
import { useGetNumberOfCardsInARow } from './use-get-number-of-cards-in-a-row';

export const useGetNumberOfRows = (
	selectedFilterItems: number[],
	topCategories: TTopCategory[],
	ROW_STEP: number
) => {
	const numberOfCardsInARow = useGetNumberOfCardsInARow();

	/**
	 * numberOfAllRows - количество рядов из услуг со всех категорий
	 *
	 * countNumberOfAllRows - функция, которая подсчитывает количество рядов либо во всех доступных категориях,
	 * 												либо в наборе категорий, который сформировался в результате фильтрации (пользователь натыкал)
	 * 		входные параметры:
	 *  	- selectedFilterItems - список id категорий, выбранных в фильтре
	 *  	- categories - данные по всем категориям
	 *		- numberOfCardsInARow - количество карточек в ряду, которое подсчитывается динамически в хуке useGetNumberOfCardsInARow
	 */

	const getNumberOfAllRows = useCallback(
		() => countNumberOfAllRows(selectedFilterItems, topCategories, numberOfCardsInARow),
		[selectedFilterItems, topCategories, numberOfCardsInARow]
	);
	const [numberOfAllRows, setNumberOfAllRows] = useState(getNumberOfAllRows());

	/**
	 * numberOfShownRows - количество рядов, которые надо показать в данный момент
	 * Значение переменной меняется по клику на кнопку "Показать еще" на шаг ROW_STEP
	 */

	const getNumberOfShownRows = useCallback(
		() => (numberOfAllRows > ROW_STEP ? ROW_STEP : numberOfAllRows),
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[numberOfAllRows]
	);
	const [numberOfShownRows, setNumberOfShownRows] = useState(getNumberOfShownRows());

	useEffect(() => {
		setNumberOfShownRows(getNumberOfShownRows());
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedFilterItems, topCategories, numberOfAllRows]);

	useEffect(() => {
		setNumberOfAllRows(getNumberOfAllRows());
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedFilterItems, topCategories, numberOfCardsInARow]);

	return {
		numberOfCardsInARow,
		numberOfAllRows,
		numberOfShownRows,
		setNumberOfShownRows,
	};
};
